import { Injectable } from "@angular/core";

@Injectable()
export class Player {
    
    constructor(){}

    player_id: number;
    first: string;
    last: string;
    email: string;
    password: string;
    gender: string;
    handicap: number;
    usga_id: number;
    usga_index: string;
    is_user: number;
    state: string;
    city: string;
    home_course: string;
    created?: any;
    image: string;
    home_course_name: string;
    is_admin: number;
    myear: number;
    troon_rewards_nbr: string;
    contact_phone: string;
    expiration_date: string;
    status: number;
    zipcode: string;
    address: string;
    is_club_admin: number;
    is_comp_admin: number;
    last_login: string;
    credit_amt: number;
    sq_customer_id: string;
    stripe_customer_id: string;
    is_premium_customer: number;
    subscription_id: string;
    default_usga_club_id: number;
}
